import React from 'react';
import { Container, Card } from '../design-system';
import { Search, ClipboardList, Palette, Code, ShieldCheck, UploadCloud, TrendingUp } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';

export function Process() {
  const { t } = useI18n();
  const steps = [
    { icon: Search, title: t('process.steps.1.title'), desc: t('process.steps.1.desc') },
    { icon: ClipboardList, title: t('process.steps.2.title'), desc: t('process.steps.2.desc') },
    { icon: Palette, title: t('process.steps.3.title'), desc: t('process.steps.3.desc') },
    { icon: Code, title: t('process.steps.4.title'), desc: t('process.steps.4.desc') },
    { icon: ShieldCheck, title: t('process.steps.5.title'), desc: t('process.steps.5.desc') },
    { icon: UploadCloud, title: t('process.steps.6.title'), desc: t('process.steps.6.desc') },
    { icon: TrendingUp, title: t('process.steps.7.title'), desc: t('process.steps.7.desc') },
  ];

  return (
    <section id="process" className="py-20 bg-white">
      <Container maxWidth="xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">{t('process.heading')}</h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">{t('process.description')}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, idx) => {
            const Icon = step.icon;
            return (
              <Card key={idx} hover>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center">
                    <Icon className="w-6 h-6 text-indigo-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-slate-900">{step.title}</h3>
                    <p className="text-slate-600 mt-1">{step.desc}</p>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
